var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcOnlineScamServiceBodyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 137,
    viewBox: "0 0 145 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2040_291)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.9441,
    cy: 60.6194,
    rx: 28.4354,
    ry: 22.342,
    fill: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.9441,
    cy: 56.5569,
    rx: 28.4354,
    ry: 22.342,
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5979 64.9033L35.4887 43.3626H40.6458L44.4541 58.5165H44.6524L48.5004 43.3626H53.6178L57.5055 58.4371H57.7038L61.4724 43.3626H66.6295L60.5204 64.9033H55.2443L51.198 50.3048H50.9203L46.8739 64.9033H41.5979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5623,
    cy: 99.8508,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5623,
    cy: 95.7883,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.216 104.136L13.1069 82.595H18.264L22.0723 97.7489H22.2706L26.1186 82.595H31.236L35.1236 97.6696H35.322L39.0906 82.595H44.2477L38.1385 104.136H32.8624L28.8161 89.5372H28.5384L24.4921 104.136H19.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4891,
    cy: 87.9289,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4891,
    cy: 83.8664,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1418 92.2139L13.0327 70.6732H18.1897L21.998 85.827H22.1964L26.0444 70.6732H31.1618L35.0494 85.7477H35.2478L39.0164 70.6732H44.1735L38.0643 92.2139H32.7882L28.7419 77.6154H28.4642L24.4179 92.2139H19.1418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4891,
    cy: 75.6702,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.4891,
    cy: 71.6077,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1418 79.9551L13.0327 58.4144H18.1897L21.998 73.5682H22.1964L26.0444 58.4144H31.1618L35.0494 73.4889H35.2478L39.0164 58.4144H44.1735L38.0643 79.9551H32.7882L28.7419 65.3566H28.4642L24.4179 79.9551H19.1418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.51,
    cy: 113.755,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.51,
    cy: 109.693,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.163 118.04L101.054 96.4993H106.211L110.02 111.653H110.218L114.066 96.4993H119.183L123.071 111.574H123.269L127.038 96.4993H132.195L126.086 118.04H120.81L116.763 103.442H116.486L112.439 118.04H107.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 101.832,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 97.7698,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.089 106.118L100.98 84.5774H106.137L109.945 99.7313H110.144L113.992 84.5774H119.109L122.997 99.652H123.195L126.964 84.5774H132.121L126.012 106.118H120.735L116.689 91.5197H116.411L112.365 106.118H107.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 89.5735,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 85.511,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.089 93.8594L100.98 72.3187H106.137L109.945 87.4725H110.144L113.992 72.3187H119.109L122.997 87.3932H123.195L126.964 72.3187H132.121L126.012 93.8594H120.735L116.689 79.2609H116.411L112.365 93.8594H107.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 77.509,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 73.4465,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.089 81.7939L100.98 60.2532H106.137L109.945 75.4071H110.144L113.992 60.2532H119.109L122.997 75.3278H123.195L126.964 60.2532H132.121L126.012 81.7939H120.735L116.689 67.1954H116.411L112.365 81.7939H107.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 66.3069,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 62.2444,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.089 70.5918L100.98 49.0511H106.137L109.945 64.205H110.144L113.992 49.0511H119.109L122.997 64.1256H123.195L126.964 49.0511H132.121L126.012 70.5918H120.735L116.689 55.9933H116.411L112.365 70.5918H107.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 55.6819,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 51.6194,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.089 59.9668L100.98 38.4261H106.137L109.945 53.58H110.144L113.992 38.4261H119.109L122.997 53.5006H123.195L126.964 38.4261H132.121L126.012 59.9668H120.735L116.689 45.3683H116.411L112.365 59.9668H107.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 46.7151,
    rx: 28.4354,
    ry: 22.342,
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.436,
    cy: 42.6526,
    rx: 28.4354,
    ry: 22.342,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.089 51L100.98 29.4593H106.137L109.945 44.6132H110.144L113.992 29.4593H119.109L122.997 44.5338H123.195L126.964 29.4593H132.121L126.012 51H120.735L116.689 36.4015H116.411L112.365 51H107.089Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2040_291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.892,
    height: 136.097,
    fill: "white",
    transform: "translate(0.0537109)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOnlineScamServiceBodyMobile);
export default __webpack_public_path__ + "static/media/IcOnlineScamServiceBodyMobile.1fc28fe95e9bca50e1bc8acc15f60971.svg";
export { ForwardRef as ReactComponent };